"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAYOUT_TYPE = {
    fuel: 'Fuel',
    taxi: 'Taxi',
    clearance: 'Pass account clearance',
    mobilityBalance: 'Mobility balance',
    driverReward: 'Driver reward',
};
